// views/js/frontend/frontend.ts
import { NetBoxProductSlider } from './product-slider';
import { NetBoxSliderTop } from './slider-top';
import { NetBoxContentBoxSlider } from './content-box-slider';
/**
 * NetBoxFrontend - Główna klasa zarządzająca funkcjonalnością frontendu
 * Zarządza inicjalizacją i cyklem życia wszystkich sliderów NetBox
 * * @class NetBoxFrontend
 */
class NetBoxFrontend {
    constructor() {
        this.productSlider = null;
        this.contentBoxSlider = null;
        this.sliderTopInstances = [];
        // Selektory CSS
        this.SLIDER_SELECTOR = '.netbox-product-swiper';
        this.SLIDER_TOP_SELECTOR = '.netbox-slider-top';
        this.CONTENT_BOX_SELECTOR = '.netbox-content-box-swiper';
        this.init();
    }
    /**
     * Inicjalizacja frontendu - obsługa DOMContentLoaded
     */
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.bootstrap());
        }
        else {
            this.bootstrap();
        }
    }
    /**
     * Bootstrap aplikacji - uruchamianie poszczególnych modułów
     */
    bootstrap() {
        try {
            this.checkDependencies();
            this.initProductSliders();
            this.initSliderTop();
            this.initContentBoxSliders();
        }
        catch (error) {
            console.error('NetBox Frontend: Critical bootstrap error', error);
        }
    }
    /**
     * Sprawdź wymagane zależności zewnętrzne (PrestaShop, Swiper)
     */
    checkDependencies() {
        if (typeof window.prestashop === 'undefined') {
            console.warn('NetBox Frontend: window.prestashop not found.');
        }
        if (typeof window.Swiper === 'undefined') {
            console.error('NetBox Frontend: Swiper library is missing. Sliders will not work.');
        }
    }
    /**
     * Inicjalizacja sliderów produktów
     */
    initProductSliders() {
        const sliders = document.querySelectorAll(this.SLIDER_SELECTOR);
        if (sliders.length === 0)
            return;
        try {
            this.productSlider = new NetBoxProductSlider();
        }
        catch (error) {
            console.error('NetBox Frontend: Product slider failed', error);
        }
    }
    /**
     * Inicjalizacja sliderów typu Content Box (np. Fuji Matcha)
     */
    initContentBoxSliders() {
        const elements = document.querySelectorAll(this.CONTENT_BOX_SELECTOR);
        if (elements.length === 0)
            return;
        try {
            this.contentBoxSlider = new NetBoxContentBoxSlider();
        }
        catch (error) {
            console.error('NetBox Frontend: Content box slider failed', error);
        }
    }
    /**
     * Inicjalizacja pasków informacyjnych (top bar)
     */
    initSliderTop() {
        const sliderTopElements = document.querySelectorAll(this.SLIDER_TOP_SELECTOR);
        if (sliderTopElements.length === 0)
            return;
        sliderTopElements.forEach((element) => {
            try {
                const instance = new NetBoxSliderTop(element);
                this.sliderTopInstances.push(instance);
            }
            catch (error) {
                console.error('NetBox Frontend: Slider-top failed', error);
            }
        });
    }
    /**
     * Cleanup przy unmount - zapobiega wyciekom pamięci
     */
    destroy() {
        if (this.productSlider && typeof this.productSlider.destroyAll === 'function') {
            this.productSlider.destroyAll();
        }
        if (this.contentBoxSlider && typeof this.contentBoxSlider.destroy === 'function') {
            this.contentBoxSlider.destroy();
        }
        this.sliderTopInstances.forEach(instance => {
            if (instance && typeof instance.destroy === 'function') {
                instance.destroy();
            }
        });
        this.sliderTopInstances = [];
    }
}
// Inicjalizacja nowej instancji frontendu
const netBoxFrontend = new NetBoxFrontend();
// Eksportujemy klasy i instancję, aby były dostępne w innych modułach
export { netBoxFrontend, NetBoxFrontend, NetBoxProductSlider, NetBoxSliderTop, NetBoxContentBoxSlider };
